import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function BicycleFacilityRequestIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.749 14C18.1632 14.0001 18.499 14.3358 18.499 14.75V17H21.249C21.6632 17.0001 21.999 17.3358 21.999 17.75C21.999 18.1642 21.6632 18.4999 21.249 18.5H18.499V21.25C18.499 21.6642 18.1632 21.9999 17.749 22C17.3348 22 16.999 21.6642 16.999 21.25V18.5H14.749C14.3348 18.5 13.999 18.1642 13.999 17.75C13.999 17.3358 14.3348 17 14.749 17H16.999V14.75C16.999 14.3358 17.3348 14 17.749 14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3C4.16421 3 4.5 3.33579 4.5 3.75V18.25C4.5 18.6642 4.16421 19 3.75 19C3.33579 19 3 18.6642 3 18.25V3.75C3 3.33579 3.33579 3 3.75 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 15C11.1642 15 11.5 15.3358 11.5 15.75V18.25C11.5 18.6642 11.1642 19 10.75 19C10.3358 19 10 18.6642 10 18.25V15.75C10 15.3358 10.3358 15 10.75 15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9C11.1642 9 11.5 9.33579 11.5 9.75V12.25C11.5 12.6642 11.1642 13 10.75 13C10.3358 13 10 12.6642 10 12.25V9.75C10 9.33579 10.3358 9 10.75 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 3C18.1642 3 18.5 3.33579 18.5 3.75V11.25C18.5 11.6642 18.1642 12 17.75 12C17.3358 12 17 11.6642 17 11.25V3.75C17 3.33579 17.3358 3 17.75 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3C11.1642 3 11.5 3.33579 11.5 3.75V6.25C11.5 6.66421 11.1642 7 10.75 7C10.3358 7 10 6.66421 10 6.25V3.75C10 3.33579 10.3358 3 10.75 3Z",
    fill: "currentColor"
  }));
}